import tableRooms from './tableRooms';
import tableMainHubThirdParty from './tableMainHubThirdParty';

export default {
  title: 'Blocking Providers',
  attributeName: 'thirdPartyAuthProvider',
  getURL: 'mainHubs/mainHubId/thirdPartyProviders',
  createURL: 'mainHubs/mainHubId/thirdPartyProviders',
  updateURL: 'mainHubs/mainHubId/thirdPartyProviders',
  removeURL: 'mainHubs/mainHubId/thirdPartyProviders',
  sessionParams: ['mainHubId'],
  idAttribute: 'id',
  tableConfig: tableMainHubThirdParty,
  // removeNameField:'name',
  // removeTitle: "Do you want to remove this third-party auth provider?",
  // removeText:'You are about to unblock the contents and the room linked to the provider',
  noArea: true,
  autoUpdate: true,
};

